import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterMoment } from '@mui/x-date-pickers-pro/AdapterMoment'
// scroll bar
import 'simplebar/src/simplebar.css';

// third-party
import { Provider as ReduxProvider } from 'react-redux';

// apex-chart
import 'assets/third-party/apex-chart.css';

// project import
import App from './App';
import { store } from 'store';


// MSAL Authentication
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

// ==============================|| MAIN - REACT DOM RENDER  ||============================== //
const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript

const pca = new PublicClientApplication(msalConfig);

root.render(
    <StrictMode>
        <ReduxProvider store={store}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
                <BrowserRouter basename="/">
                    <App msalInstance={pca} />
                </BrowserRouter>
            </LocalizationProvider>
        </ReduxProvider>
    </StrictMode>
);
